import { ResultOk } from "@/types/resultok";
import { api } from "..";
import { buildQueryString } from "./utils";
import { UserProfile } from "@/types/user";

export const wxLoginApi = api.injectEndpoints({
  endpoints: (build) => ({
    // 通过code获取access_token
    wxtoken: build.query<UserProfile, {code: string}>({
      query:(params)=>`/users/wxtoken${buildQueryString(params)}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data
    }),
    wxsave:build.mutation<UserProfile,UserProfile>({
      query:(body)=>({
        url:`/users/wxsave`,
        method:"POST",
        body
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data
    }),
    wxsend:build.mutation<ResultOk,{phone:string}>({
      query:(body)=>({
        url:`/users/wxsend`,
        method:"POST",
        body
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data
    })
  })
});

export const { useWxsaveMutation,useLazyWxtokenQuery,useWxsendMutation } = wxLoginApi